import clsx from 'clsx';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import { useLeadsWindow } from '../context/LeadsWindowContext';
import { navActionButtonClass } from '../components/layout/navActionButton';

const LABEL = 'Leads Tracker';

/** Leads Tracker launcher in the top navbar — label stays static. */
export default function LeadsTaskbar({ className }) {
  const { open, restore, openLeads, stepLabel: step } = useLeadsWindow();

  const handleClick = () => {
    if (open) restore();
    else openLeads();
  };

  const tooltip =
    open && step
      ? `Resume Leads Tracker · ${step}`
      : open
        ? 'Resume Leads Tracker'
        : 'Open Leads Tracker';

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={open ? 'Restore Leads Tracker' : 'Open Leads Tracker'}
      title={tooltip}
      className={clsx(navActionButtonClass({ active: open }), className)}
    >
      <ChartBarIcon className="h-4 w-4 shrink-0 text-primary-600" strokeWidth={2} />
      <span className="truncate max-w-[9rem]">{LABEL}</span>
    </button>
  );
}
